<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Configuración Agenda</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>C-**</div>
        </b-col>
      </b-row>


      <div class="divSubtitulo">
        <p class="textoSubtitulo" style="font-size: 18px;">  Búsqueda de agenda</p>
      </div><br>

      <b-row>
        <b-col>

          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label for="nombreBusq">Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="descripcion" placeholder="Nombre de la agenda"
                                v-model="filtro.palabraClave" @keydown.enter.native="obtenerConfiguracionAgenda"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right">
              <b-button v-b-tooltip.hover title="Agregar agenda" variant="outline-primary"
                        @click="agregar()">Agregar agenda
              </b-button>
            </b-col>

          </b-row>

        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>

            <template v-slot:cell(fechaModificacion)="row">
              {{ row.item.fechaModificacion | formatoFechaCorta}}
            </template>

            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button title="Modificar agenda"
                          size="sm"
                          @click="modificar(row.item)"
                          variant="outline-warning"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button v-if="!row.item.registroActivo"
                          title="Activar permiso"
                          variant="outline-danger"
                          size="sm"
                          @click="activarDesactivarEstatus(row.item)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-else
                          title="Desactivar permiso"
                          variant="outline-danger"
                          size="sm"
                          @click="activarDesactivarEstatus(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>

            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>

      </b-row>
    </b-card>

    <b-modal
        v-model="show"
        :title="tituloModal"
        size="xl"
        scrollable
    >
      <b-form @submit.stop.prevent="guardar">
        <b-container fluid>
          <b-row>
            <b-col>

              <div class="row">

                <div class="col-4">
                  <b-form-group align="left">
                    <label for="etiquetaCategoria">Nombre de la agenda</label>
                    <b-input-group size="sm" class="mb-2" id="etiquetaCategoria">
                      <b-input-group-prepend is-text>
                        <b-icon icon="menu-button-wide"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input name="etiqueta" placeholder="Nombre de la agenda"
                                    v-model="$v.agendaLinea.etiquetaCategoria.$model"
                                    :state="validateState('etiquetaCategoria')"
                                    rows="3"
                                    max-rows="6"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>

              <div class="col-4">
                <b-form-group align="left">
                  <label for="peso">Peso</label>
                  <b-input-group size="sm" class="mb-2" id="etiquetaCategoria">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input name="peso" placeholder="Agregar peso"
                                  v-model="$v.agendaLinea.peso.$model"
                                  :state="validateState('peso')"
                                  rows="3"
                                  max-rows="6"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
                <div class="col-4"
                     style="display:flex;align-items:center">
                  <b-form-checkbox v-model="agendaLinea.opcionPacienteRegistrado" name="check-button" switch>Paciente registrado
                  </b-form-checkbox>
                </div>
              </div>

              <div class="row">
                <div class="col-4">
                  <b-form-group
                      label="Lista canal origen"
                      label-align="left"
                      class="mginInputTrt"
                  >
                    <v-select
                        v-model="agendaLinea.idCanalOrigen"
                        :options="canal"
                        label="descripcionCanal"
                        :reduce="(item) => item.idCanalOrigen">
                    </v-select>
                    <b-form-invalid-feedback :state="agendaLinea.idCanalOrigen != null">
                      Selecionar canal origen
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
                  <div class="col-4">
                    <b-form-group
                        label="Lista dentición"
                        label-align="left"
                        class="mginInputTrt"
                    >
                      <v-select
                          v-model="agendaLinea.idDenticion"
                          :options="denticion"
                          label="descripcionDen"
                          :reduce="(item) => item.idDenticion">
                      </v-select>
                      <b-form-invalid-feedback :state="agendaLinea.idDenticion != null">
                        Selecionar tipo dentición
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>

              <div class="col-4">
                <b-form-group
                    label="Lista tag motivo cita"
                    label-align="left"
                    class="mginInputTrt"
                >
                  <v-select
                      v-model="agendaLinea.idTagMotivoCita"
                      :options="tagMotivo"
                      label="descripcionTagMotivoCita"
                      :reduce="(item) => item.idTagMotivoCita">
                  </v-select>
                </b-form-group>
              </div>

                <div class="col-6">
                  <b-form-group
                      label="Lista tratamientos"
                      label-align="left"
                      class="mginInputTrt"
                  >
                    <v-select
                        v-model="agendaLinea.idTratamiento"
                        :options="tratamiento"
                        label="descripcion"
                        :reduce="(item) => item.idTratamiento">
                    </v-select>
                  </b-form-group>
                </div>

                <div class="col-6">
                  <b-form-group
                      label="Lista configuración perfil"
                      label-align="left"
                      class="mginInputTrt"
                  >
                    <v-select
                        v-model="agendaLinea.idConfiguracion"
                        :options="configuracionP"
                        label="nombreConfiguracion"
                        :reduce="(item) => item.idConfiguracion">
                    </v-select>
                    <b-form-invalid-feedback :state="agendaLinea.idConfiguracion != null">
                      Selecionar configuración
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>

              </div>

              <br><br>

            </b-col>
          </b-row>
        </b-container>
        <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
      </b-form>

      <template v-slot:modal-footer>
        <b-button variant="outline-primary" @click="submitGuardar" :disabled="loaderAcciones || agendaLinea.idCanalOrigen == null
        || agendaLinea.idDenticion == null || agendaLinea.idConfiguracion == null">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                        Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </template>

    </b-modal>

  </div>
</template>

<script>
import Header from "@/components/Header";
import {required} from "vuelidate/lib/validators";

export default {
  name: "configuracionAgenda",
  components: { Header },

  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    configuracionP: [],
    tratamiento: [],
    tagMotivo: [],
    denticion: [],
    canal: [],
    datosTabla: [],
    fields: [
      {key: "idConfiguracionAgenda", label: "ID", sortable: true},
      {key: "descripcionCanal", label: "Canal origen", sortable: true},
      {key: "descripcionDen", label: "Tipo dentición", sortable: true},
      {key: "descripcionTagMotivoCita", label: "Tag", sortable: true},
      {key: "descripcion", label: "Tratamiento", sortable: true},
      {key: "peso", label: "Peso", sortable: true},
      {key: "etiquetaCategoria", label: "Etiqueta Categoria", sortable: true},
      {key: "nombreConfiguracion", label: "Configuración", sortable: true},
      {key: "fechaModificacion", label: "Fecha modificación", sortable: true},
      {key: "nombreUsuarioModificacion", label: "Usuario modificación", sortable: true},
      "Acciones"
    ],
    paginaActual: 1,
    show: false,
    tituloModal: '',
    agendaLinea: {
      idConfiguracionAgenda: null,
      etiquetaCategoria: null,
      idCanalOrigen: null,
      descripcionCanal: null,
      idDenticion: null,
      descripcionDen: null,
      idTagMotivoCita: null,
      descripcionTagMotivoCita: null,
      idTratamiento: null,
      descripcion: null,
      peso: null,
      opcionPacienteRegistrado: true,
      idConfiguracion: null,
      nombreConfiguracion: null
    },
    filtro: {
      id: null,
      palabraClave: null,
      registroActivo: null
    },
    loaderAcciones: false,
    loader: false,
  }),
  validations: {
    agendaLinea: {
      etiquetaCategoria: {required},
      peso: {required},
      pacienteRegistro: {},
    }
  },

  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerConfiguracionAgenda();
    this.listaCanal();
    this.listaDenticion();
    this.listaTagMotivoCita();
    this.listaTratamiento();
    this.listaConfiguracionPerfil();
  },

  methods: {

    modificar(item) {
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.agendaLinea = JSON.parse(JSON.stringify(item));
      this.tituloModal = 'Modificar agenda';
      this.show = true;
    },

    cerrarModal() {
      this.show = false;
    },
    agregar() {
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.agendaLinea = {},
      this.tituloModal = 'Agregar agenda';
      this.show = true;
    },

    submitGuardar() {
      this.$refs.submitGuardar.click();
    },


    guardar() {
      this.$v.agendaLinea.$touch();
      if (this.$v.agendaLinea.$anyError) {
        return;
      }
      if (!this.$v.agendaLinea.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'configuracionAgenda/guardarAgenda', this.agendaLinea).then(respuesta => {
              if (respuesta.data.data) {
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "La agenda se registró correctamente",
                });
                this.filtro.palabraClave = this.agendaLinea.etiquetaCategoria;
                this.obtenerConfiguracionAgenda();
                this.show = false;
              }
            }
        ).catch(error => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "La agenda ya existe",
          });
        }).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    },

    listaCanal() {
      this.$http.post(this.$api + 'configuracionAgenda/obtenerCanal').then(respuesta => {
        if (respuesta.data.data) {
          this.canal = respuesta.data.data;
        }
      })
          .catch((err) => {
            this.errorMensaje(err);
          });
    },

    listaDenticion(){
      this.$http.post(this.$api + 'configuracionAgenda/obtenerDenticion').then(respuesta => {
        if (respuesta.data.data) {
          this.denticion = respuesta.data.data;
        }
      })
          .catch((err) => {
            this.errorMensaje(err);
          });
    },

    listaTagMotivoCita() {
      this.$http.post(this.$api + 'configuracionAgenda/obtenerTagMotivoCita').then(respuesta => {
        if (respuesta.data.data) {
          this.tagMotivo = respuesta.data.data;
        }
      })
          .catch((err) => {
            this.errorMensaje(err);
          });
    },

    listaTratamiento() {
      this.$http.post(this.$api + 'configuracionAgenda/obtenerTratamiento').then(respuesta => {
        if (respuesta.data.data) {
          this.tratamiento = respuesta.data.data;
        }
      })
          .catch((err) => {
            this.errorMensaje(err);
          });
    },

    listaConfiguracionPerfil() {
      this.$http.post(this.$api + 'configuracionAgenda/obtenerConfiguracionPerfil').then(respuesta => {
        if (respuesta.data.data) {
          this.configuracionP = respuesta.data.data;
        }
      })
          .catch((err) => {
            this.errorMensaje(err);
          });
    },

    obtenerConfiguracionAgenda(){
      this.loader = true;
      this.datosTabla = [];
      this.$http.post(this.$api + 'configuracionAgenda/obtenerAgenda', this.filtro).then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.paginaActual=1;
                this.datosTabla.push(it);
              })
            }
          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },

    activarDesactivarEstatus(item) {
      const mensaje = item.registroActivo
          ? "¿Está seguro de desactivar la agenda?"
          : "¿Está seguro de activar la agenda?";
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idConfiguracionAgenda: item.idConfiguracionAgenda,
          }
          this.$http.post( this.$api + 'configuracionAgenda/activarDesactivar', parametros)
              .then((respuesta) => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El tipo de solicitud se actualizó correctamente",
                  });
                  this.obtenerConfiguracionAgenda();
                }
              });
        }
      });
    },

    validateState(name) {
      const {$dirty, $error} = this.$v.agendaLinea[name];
      return $dirty ? !$error : null;
    },

  }
};
</script>

<style scoped>
</style>